import TechnologyChangesPeriod from "app/pages/sales-intelligence/sub-modules/signals/models/technology/TechnologyChangesPeriod";

export const technologyRenewalPeriodOptions = [TechnologyChangesPeriod.Quarter, TechnologyChangesPeriod.HalfYear];

export const technologyRenewalPeriodToValue = {
    [TechnologyChangesPeriod.Quarter]: 3,
    [TechnologyChangesPeriod.HalfYear]: 6,
};

export const technologyRenewalValueToPeriod = {
    3: TechnologyChangesPeriod.Quarter,
    6: TechnologyChangesPeriod.HalfYear,
};
